import { RouterProvider } from "react-router-dom";
import { router } from "@/app/router";
import { Toaster } from "@/components/ui/sonner";
import { ConfigProvider } from "antd";
import { theme } from "@/config/theme";

export default function App() {
  return (
    <ConfigProvider theme={theme}>
      <RouterProvider router={router} />
      <Toaster position="top-right" richColors />
    </ConfigProvider>
  );
}
